export default __webpack_public_path__ + "static/media/checkbox-content.d29856a5.svg";